

























import { Component, Provide, Vue } from 'vue-property-decorator';
import FieldFile from '@/components/form/FieldFile.vue';
import { StoreActions } from '@/store';
import { required } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';

@Component({
  mixins: [validationMixin],
  components: {
    FieldFile,
  },
  validations: {
    file: {
      required,
    }
  }
})
export default class Upload extends Vue {
  @Provide() file: string = ''

  async submit() {
    await this.$store.dispatch(StoreActions.Upload, this.getFormData());
  }

  getFormData() {
    const data = new FormData();
    data.append('file', this.file);
    return data;
  }
}
